export default "<app-faq-banner title=\"ACP Portal Education\"></app-faq-banner>\r\n<app-faq-viewer [faq]=\"faq\" [loading]=\"loading\"></app-faq-viewer>\r\n"